import _ from 'underscore';
import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive';

export const Frequency = memo(({
  id,
  cronFormatter,
  onChange,
  selected,
  className,
  enabledFrequencies,
  ariaLabelledby,
}) => {
  const [selectedFrequency, setFrequency] = useState(selected.toString());

  const cronFrequencies = cronFormatter.getCronFrequenciesEnum();
  const noneFrequency = cronFrequencies.NONE;
  const frequencies = enabledFrequencies ?
    [noneFrequency, ...enabledFrequencies] : _.values(cronFrequencies);

  return (
    <Select
      id={id}
      className={className}
      value={selectedFrequency}
      onChange={(event) => {
        const frequency = parseInt(event.target.value, 10);
        setFrequency(frequency.toString());
        onChange(frequency);
      }}
      aria-labelledby={ariaLabelledby}
    >
      {frequencies.map(frequency =>
        (
          <option
            key={frequency}
            value={frequency}
          >
            {cronFormatter.formatCronFrequencyUpperCase(frequency)}
          </option>
        ))}
    </Select>
  );
});

Frequency.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string.isRequired,
  cronFormatter: PropTypes.shape({
    formatCronFrequency: PropTypes.func,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.number.isRequired,
  enabledFrequencies: PropTypes.arrayOf(PropTypes.number),
  ariaLabelledby: PropTypes.string,
};

Frequency.defaultProps = {
  id: undefined,
  enabledFrequencies: undefined,
  ariaLabelledby: '',
};
